import Vue from "vue";
import store from "@/store";
import i18n from "@/util/language";
import { getIn } from "@/util/manipulate";
import { getLanguageStr } from "@/util/language";
import * as lib from "@/util/lib";

window.$ = window.jQuery = $;
require("@/util/third/jquery.mCustomScrollbar.min");
require("@/util/third/jquery-ui.min");
require("@/util/third/jquery.mousewheel.min");

// body 事件处理
$("body").on("mouseover", ".mCSB_dragger_bar", function () {
	$(this)
		.parents(".mCSB_scrollTools_onDrag_expand")
		.each(function () {
			$(this).addClass("hasclick");
		});
});
$("body").on("mouseout", ".mCSB_dragger_bar", function () {
	$(this)
		.parents(".mCSB_scrollTools_onDrag_expand")
		.each(function () {
			$(this).removeClass("hasclick");
		});
});

require("@/directives/permission");
import DatePicker from "@/plugins/datePicker";
Vue.use(DatePicker);
import Debounce from "vue-preventedup-plugin";
Vue.use(Debounce, { DebounceTime: 200, ThrottleTime: 200 });
import Notify from "@/plugins/notify";
import Message from "@/plugins/message";
Vue.use(Notify);
Vue.prototype.$Message = Message;
import toast from "@/plugins/toast";
Vue.use(toast);

import Dynamic from "@/plugins/dynamic";
Vue.use(Dynamic, {
	plugin: {
		router,
		store,
		i18n,
		Debounce,
	},
});

stage.token = lib.getUrlParam("token");
stage.useMode = lib.getUrlParam("useMode");
// 为了解决设备控制手机端卡顿现象，ip方案处理
if (!stage.token) {
	lib.getIpToDo(null, 4);
}

// 全局常用UI组件库 begin
import VTree from "@/components/common/ui/vTree/Tree";
import AddFile from "@/components/common/ui/AddFile";
import AreaInput from "@/components/common/ui/AreaInput";
import Checkbox from "@/components/common/ui/Checkbox";
import Confirm from "@/components/common/ui/Confirm";
import DashLine from "@/components/common/ui/DashLine";
import FunctionButton from "@/components/common/ui/FunctionButton";
import InputPhone from "@/components/common/ui/InputPhone";
import InputText from "@/components/common/ui/InputText";
import Label from "@/components/common/ui/Label";
import Loading from "@/components/common/ui/Loading";
import Logo from "@/components/common/ui/Logo";
import NoResult from "@/components/common/ui/NoResult";
import OnOff from "@/components/common/ui/OnOff";
import Pagination from "@/components/common/ui/Pagination";
import Panel from "@/components/common/ui/Panel";
import Radio from "@/components/common/ui/Radio";
import RadioGroup from "@/components/common/ui/RadioGroup";
import Rate from "@/components/common/ui/Rate";
import Select from "@/components/common/ui/Select";
import SelectColor from "@/components/common/ui/SelectColor";
import SelectMember from "@/components/common/ui/SelectMember";
import StatusIco from "@/components/common/ui/StatusIco";
import Stroke from "@/components/common/ui/Stroke";
import TagBox from "@/components/common/ui/TagBox";
import TagForm from "@/components/common/ui/TagForm";
import VerificationCode from "@/components/common/ui/VerificationCode";
import WindowForAlert from "@/components/common/ui/WindowForAlert";
import WindowForNew from "@/components/common/ui/WindowForNew";
import WindowForSetting from "@/components/common/ui/WindowForSetting";
import WindowForView from "@/components/common/ui/WindowForView";
// 全局UI组件库 end

const install = (Vue, opts = {}) => {
	// 导入全局UI组件 begin
	const components = {
		VTree,
		AddFile,
		AreaInput,
		Checkbox,
		Confirm,
		DashLine,
		FunctionButton,
		InputPhone,
		InputText,
		Label,
		Loading,
		Logo,
		NoResult,
		OnOff,
		Pagination,
		Panel,
		Radio,
		RadioGroup,
		Rate,
		Select,
		SelectColor,
		SelectMember,
		StatusIco,
		Stroke,
		TagBox,
		TagForm,
		VerificationCode,
		WindowForAlert,
		WindowForNew,
		WindowForSetting,
		WindowForView,
	};
	Object.keys(components).forEach((key) => {
		Vue.component(key, components[key]);
	});
	// 导入全局组件 end

	Vue.prototype.$bus = new Vue();
	Vue.prototype.getIn = getIn;
	Vue.prototype.getLanguageStr = getLanguageStr;
	Vue.prototype.timeFormat = lib.timeFormat;
	Vue.prototype.getTypeText = lib.getTypeText;
	Vue.prototype.fillHeight = lib.fillHeight;
	Vue.prototype.setScroll = lib.setScroll;
	Vue.prototype.setNewScroll = lib.setNewScroll;
};

if (typeof window !== "undefined" && window.Vue) {
	install(window.Vue);
}

Vue.use(install);



// WEBPACK FOOTER //
// ./src/plugins/index.js